import * as React from 'react';
import { formatDate } from '../../../../shared/LanguageService';
import set from 'date-fns/set';
import PhotographerCalendarApi from '../../../photographerBooking/se360/SE360PhotographerBookingApi';
import { useTelemetryContext } from '../../../../telemetry/telemetryContext';
import ICalendarItem from '../../../calendar/Types';

function splitHoursAndMinutes(time: string): number[] {
    return time.split(':').map(Number);
}

function useSubmitBooking<T extends any[]>(
    bookingInfo,
    selectedBookingDate,
    selectedOrder,
    isAdvancedMode,
    user,
    history
) {
    let { logger } = useTelemetryContext();
    let [showBookingFailureSnackbar, setShowBookingFailureSnackbar] =
        React.useState<boolean>(false);

    function handleCloseBookingFailureSnackbar() {
        setShowBookingFailureSnackbar(false);
    }

    async function handleBooking() {
        let bookingEnd = formatDate(new Date(bookingInfo.end), 'kk' + ':' + 'mm');
        let bookingStart = formatDate(new Date(bookingInfo.start), 'kk' + ':' + 'mm');
        let [endHours, endMinutes] = splitHoursAndMinutes(bookingEnd);
        let endDate = set(selectedBookingDate, {
            hours: endHours,
            minutes: endMinutes
        });

        let [startHours, startMinutes] = splitHoursAndMinutes(bookingStart);
        let startDate = set(selectedBookingDate, {
            hours: startHours,
            minutes: startMinutes
        });
        let photographerId = bookingInfo.userId;
        let calendarItemType = selectedOrder.site;
        let calendarItem: Partial<ICalendarItem> = {
            id: 0,
            orderId: selectedOrder.orderId,
            end: endDate,
            start: startDate,
            userId: photographerId,
            type: calendarItemType
        };

        try {
            await PhotographerCalendarApi.updatePhotographerCalendar({
                calendarItem,
                planOrderId: null,
                isAdvanced: isAdvancedMode
            });
            history.push(`/orders/${selectedOrder.orderId}/basic`);
        } catch (error) {
            setShowBookingFailureSnackbar(true);
            let additionalInformation = {
                origin: 'BookingsListCalendar.handleBook',
                userInfo: user
            };
            logger.logException(error, additionalInformation);
        }
    }

    return { showBookingFailureSnackbar, handleBooking, handleCloseBookingFailureSnackbar };
}

export default useSubmitBooking;
